import {
    Component, Input, Output, EventEmitter,
    OnInit, OnChanges, OnDestroy, ViewChild, ElementRef,
    Inject
} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as _ from 'lodash';

// vis
import * as vis from 'vis';
import { NavVisOptions } from '../../model/nav-vis-options';

// config
import { navigationConfig } from '../../config/navigation.config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';
import { UiMessageSnackService } from '../../../core/components/message-snack/service/message-snack.service';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// foreign feature
import {
    breadcrumbAddCrumb, breadcrumbSetInitialCrumb, breadcrumbAddCrumbAndShrink
} from '../../../core/components/breadcrumb/store/actions';
import { IBreadcrumbItem } from '../../../core/components/breadcrumb/model/breadcrumb.interface';

// Own feature
import { NavigationService } from '../../service/navigation.service';
import { NavElementsContainer } from '../../model/nav-elements-container';
import { INavDisplayOptions, NAV_DISPLAY_OPTIONS_INITIAL_STATE } from '../../model/nav-display-options.interface';
import { INavGraphDisplayOptionEdges } from '../../model/nav-display-edgegroup-pairs';
import {
    navigationStoreResult1stInitialValue,
    navigationStore1stDisplayOptionEdges,
    navigationStoreSchema,
    navigationStoreResult1stDetail
} from '../../store/actions';
import { NavElementsRoot } from '../../model/nav-elements-root';

// import
import { gNavElementContainer, gVirtualRootId, gNavContainer } from '../../compc/nav-cont/nav-cont.component';
import { INavNewEdgeAndElement } from '../../model/nav-new-edge-element.interface';
import { INavElementsNode } from '../../model/nav-elements-nodegroup';
import { appConfig } from '../../../config/app-config';
import { ReloadContent } from '../../model/reload-content.abstract';
import { ConfirmDialogsService } from '../../../core/components/confirm-dialog/service/confirm-dialog.service';
import { INavElementsEdge } from '../../model/nav-elements-edgegroup';
import { CreateElementService } from '../../service/create-element.service';
import { IEdgeDictionaryEntry } from '../../store/store';
import { LoadingphaseService } from '../../service/loadingphase.service';

@Component({
    selector: 'app-nav-graph1',
    templateUrl: './nav-graph1.html',
    styleUrls: ['./nav-graph1.scss']
})
export class NavGraph1Component implements OnInit, OnChanges, OnDestroy, ReloadContent {
    private static firstLoad = true;
    private readonly = true;
    private _selectedNodes: vis.IdType[];
    private _hoveredNode: vis.IdType;
    // titel/subtitel for search graph mdlg
    private readonly _titleMdlgCreateElement = 'Neues Element';
    private readonly _subtitleMdlgCreateElement = 'mit Beziehung zu ';
    public titleMdlgCreateElement = '';
    public subtitleMdlgCreateElement = '';

    // loading data
    public set _loadingPhase(value: boolean) {
        this._loadingphaseService.setContentBlockState(value);
        this._loadingphaseService.setLoadingphase(value, 'nav_graph');
    }

    // graph container
    private navElementContainer: NavElementsContainer = null;
    private _graph: vis.Network = null;

    // selection
    private _rightClickSelectedNodeID = '';

    // drawer
    public drawerIsOpen = false;

    // vis options
    private _visOptions: vis.Options = {
        autoResize: true,
        clickToUse: false,
        width: '100%',
        height: '97%',
        edges: {
            arrows: 'to',
            width: 1,
            font: {
                size: 9,
            }
        },
        locale: 'en',
        nodes: {
            shape: 'box',
            color: {
                highlight: {
                    border: '#FF0000',
                }
            }
        },
        interaction: {
            hover: true,
            navigationButtons: false,
            selectable: true,
            tooltipDelay: 300
        },
        layout: {
            improvedLayout: false,
        }
    };

    // Input
    @Input() public elementsResultInit: any = null;
    @Input() public elementOptions: INavDisplayOptions = NAV_DISPLAY_OPTIONS_INITIAL_STATE;
    @Input() public breadcrumbSelected: IBreadcrumbItem = null;

    // Children
    @ViewChild('drawingArea') private _containerElemRef: ElementRef;
    // Context Menu
    @ViewChild('contextMenuContainer') public readonly _contextMenuContainerElemRef: ElementRef;
    @ViewChild(MatMenuTrigger) public readonly _contextMenuTrigger: MatMenuTrigger;

    // observables
    @select((s: IAppState) => s.navigationState.element1stDisplayOptionEdges) displayOptionEdges$;

    // Constructor
    constructor(
        private _store: NgRedux<IAppState>,
        private _navigationService: NavigationService,
        private _messageSnackService: UiMessageSnackService,
        private _viewOptionDlg: MatDialog,
        private _confirmDialogService: ConfirmDialogsService,
        private _createElementService: CreateElementService,
        private _loadingphaseService: LoadingphaseService,
    ) {
        // import navElementContainer
        this.navElementContainer = gNavElementContainer;
    }

    ngOnInit() {

        const vRoot = this.navElementContainer.getVirtualRoot();
        const elements1Initial = this._store.getState().navigationState.elementsResult1stInitial;
        // initialize navElementContainer if not already done
        this.navElementContainer.computeInitialSearchResult(
            elements1Initial,
            this._store.getState().navigationState.config
        );
        if (vRoot && vRoot.rootObj) {
            this.navElementContainer.resetVirtualRoot(vRoot.rootObj.id);
        }
        this.navElementContainer.applyDisplayFilter(this.elementOptions);

        // set breadcrumb only on first pageload
        if (NavGraph1Component.firstLoad) {
            NavGraph1Component.firstLoad = false;
            const ner: NavElementsRoot = this.navElementContainer.getVirtualRoot();

            const dict = Array.from(this._store.getState().navigationState.config['dictionary'])
                .find((value) => value['key'] === ner.rootObj.group);



            this._store.dispatch(breadcrumbSetInitialCrumb(
                {
                    message: `${dict && dict['short'] || ''} ${ner.rootObj.label}`,
                    value: ner.rootObj.id
                },
                0

            ));
        }

        NavVisOptions.setVisOptions(this._visOptions, this._store.getState().navigationState.config);

        // set edge group pairs for selection
        const displayOptionEdges: INavGraphDisplayOptionEdges[] =
            _.cloneDeep(this._store.getState().navigationState.element1stDisplayOptionEdges);
        this.navElementContainer.fillDisplayOptionEdges(displayOptionEdges);
        this._store.dispatch(navigationStore1stDisplayOptionEdges(displayOptionEdges));

        // setup graph
        this._graph = new vis.Network(
            this._containerElemRef.nativeElement,
            this.navElementContainer.generateVisData(this._store.getState().navigationState, this.elementOptions),
            this._visOptions);

        // reselect nodes
        if (gVirtualRootId.length > 0) {
            try {
                this._graph.selectNodes(gVirtualRootId, true);
            } catch (err) {
                console.warn('Wiederherstellen des Virtuellen Root fehlgeschlagen');
            }
        }

        // user interaction
        this._graph.on('selectNode', this.onSelectNode.bind(this));
        this._graph.on('deselectNode', this.onDeselectNode.bind(this));
        this._graph.on('oncontext', this.onContext.bind(this));
        this._graph.once('dragging', this.onDragging.bind(this));
        this._graph.on('dragEnd', this.onDragEnd.bind(this));
        this._graph.on('zoom', this.onZoom.bind(this, this._graph, 0.3));
        this._graph.on('hoverNode', this.onHoverNode.bind(this));
        this._graph.on('blurNode', this.onBlurNode.bind(this));
        this._graph.on('blurEdge', this.onBlurEdge.bind(this));
        this._graph.on('stabilizationProgress', this.onStabilizationProgress.bind(this));
        this._graph.on('stabilizationIterationsDone', this.onStabilizationIterationsDone.bind(this));
    }

    ngOnDestroy() {
        if (this._graph) {
            this._graph.destroy();
            this._graph = null;
        }
    }

    ngOnChanges(changes: any) {
        if (!this.elementsResultInit || !this._graph) { return; }


        // breadcrumb
        if (changes.breadcrumbSelected) {
            const ch = changes.breadcrumbSelected;
            if (ch.firstChange || ch.currentValue !== ch.previousValue) {
                this.onSelectNode({
                    event: {
                        srcEvent: {
                            ctrlKey: false
                        }
                    },
                    nodes: [
                        ch.currentValue.value
                    ]
                }, true);
                return;
            }
        }

        // parse searchResult
        if (changes.elementsResultInit) {            // detect changes
            const ch = changes.elementsResultInit;
            if (ch.firstChange || ch.currentValue !== ch.previousValue) {
                // setup container
                this.navElementContainer.computeInitialSearchResult(
                    this.elementsResultInit,
                    this._store.getState().navigationState.config
                );
            }
        }

        this.navElementContainer.applyDisplayFilter(this.elementOptions);
        // setup graph
        this._graph.setData(this.navElementContainer.generateVisData(this._store.getState().navigationState, this.elementOptions));
        this._graph.redraw();

        // set breadcrumb
        const ner: NavElementsRoot = this.navElementContainer.getVirtualRoot();

        const dict = Array.from(this._store.getState().navigationState.config['dictionary'])
            .find((value) => value['key'] === ner.rootObj.id.split('/')[0]);

        this._store.dispatch(breadcrumbSetInitialCrumb(
            {
                message: `${dict && dict['short'] || ''} ${ner.rootObj.label}`,
                value: ner.rootObj.id
            },
            0
        ));

        // save selected Nodes
        if (gVirtualRootId.length > 0) {
            gVirtualRootId.pop();
        }
        if (ner.rootObj.id !== navigationConfig.loadRespondDataVirtualRootIdentifier) {     // result
            gVirtualRootId.push(ner.rootObj.id);
        }

        // set edge group pairs for selection
        const displayOptionEdges: INavGraphDisplayOptionEdges[] =
            _.cloneDeep(this._store.getState().navigationState.element1stDisplayOptionEdges);
        this.navElementContainer.fillDisplayOptionEdges(displayOptionEdges);
        this._store.dispatch(navigationStore1stDisplayOptionEdges(displayOptionEdges));

        // Keine Ahnung warum, aber im Code wird auf 2 Unterschiedliche Arten geprüft, ob der "Suchergebnis" -Knoten selektiert ist.
        // Hier also besser mal auf beides prüfen...
        // load detail
        if (ner.rootObj.group !== navigationConfig.loadRespondDataVirtualRootIdentifier
            && ner.rootObj.id !== navigationConfig.defaultValuesForRoot.id) {
            this._navigationService.loadElements1stDetail(
                ner.rootObj.id
            )
                .then((boolResultASY: IBoolResult) => {

                    // result available
                    if (boolResultASY.result) {
                        return;
                    }
                    this._loadingPhase = false;
                    // no data
                    this._messageSnackService.showSnackWarning(boolResultASY.message.message, 'NavElemGraphViewComponent');
                })
                .catch((err: ErrorMessage) => {
                    this._loadingPhase = false;
                    this._messageSnackService.showSnackError(err.message, 'NavElemGraphViewComponent');
                });
        }
        this._selectedNodes = [ner.rootObj.id];
        this.onSelectNode(
            {
                nodes: this._selectedNodes,
            }
        );
        const details = this._store.getState().navigationState.element1stDetail;
        if (details) {
            const node = this._graph.getPositions(details.data._id);
            if (!Object.keys(node).length) {
                this._store.dispatch(navigationStoreResult1stDetail(undefined));
            } else {
                this._graph.selectNodes([details.data._id]);
                this.onSelectNode({
                    nodes: [details.data._id],
                });
            }
        }
    }

    public reloadContent() {

        // sanity
        if (!this.elementsResultInit || !this._graph) { return; }

        // setup graph with current display filter
        this._graph.setData(this.navElementContainer.generateVisData(this._store.getState().navigationState, this.elementOptions));

        // reselect nodes
        if (this._selectedNodes) {
            try {
                this._graph.selectNodes(this._selectedNodes, true);
            } catch (err) {
                this._selectedNodes = undefined;
                this._graph.unselectAll();
            }
        }

        this._graph.redraw();
    }

    // ---------------------------------------------------------------------------------------------
    // -- Event handling
    // ---------------------------------------------------------------------------------------------

    /**
    * Callback function, wird von vis für das handling von Node-Select Events aufgerufen.
    *
    * @param [param: any] Parameter von vis für Interactinen.
    * @returns void
    */
    private onSelectNode(params, update: boolean = false): void {
        for (const node of this._selectedNodes || []) {
            if ((node as string).startsWith('KomponenteGA')) {
                this.navElementContainer.setSVG(node as string, '', '');
            }
        }
        this._selectedNodes = params.nodes;
        for (const node of this._selectedNodes || []) {
            if ((node as string).startsWith('KomponenteGA')) {
                this.navElementContainer.setSVG(node as string,
                    this._visOptions.groups.KomponenteGA.color.hover.background,
                    (this._visOptions.nodes.color.highlight as { border: string }).border);
            }
        }
        // define neu virtual root
        this.navElementContainer.resetVirtualRoot(params.nodes[0]);
        if (update) {
            // parse searchResult
            this.navElementContainer.applyDisplayFilter(this.elementOptions);
            // setup graph
            this._graph.setData(this.navElementContainer.generateVisData(this._store.getState().navigationState, this.elementOptions));
            this._graph.redraw();
        }
        // set breadcrumb
        const ner: NavElementsRoot = this.navElementContainer.getVirtualRoot();

        const dict = Array.from(this._store.getState().navigationState.config['dictionary'])
            .find((value) => value['key'] === ner.rootObj.group);

        this._store.dispatch(breadcrumbAddCrumb(
            {
                message: `${dict && dict['short'] || ''} ${ner.rootObj.label}`,
                value: ner.rootObj.id
            },
            0
        ));

        // show details
        this.onContextDetails();
        this._graph.selectNodes(this._selectedNodes, true);

        // save selected Nodes
        if (gVirtualRootId.length > 0) {
            gVirtualRootId.pop();
        }
        gVirtualRootId.push(this._selectedNodes[0] as string);
    }

    private onDeselectNode(params) {
        if (!params.nodes.length) {
            const previousSelection = params.previousSelection;
            this._graph.selectNodes(previousSelection.nodes);
        }
    }

    private displayEdit(): boolean {
        if (this._rightClickSelectedNodeID && this._rightClickSelectedNodeID.startsWith('BereichGebaeude')) {
            const config = this._store.getState().navigationState.config;
            return !!config.edgeDefinitions['BereichGebaeude'];
        }
        return !this.readonly;
    }

    private onDragging(params) {
        if (!this._selectedNodes) {
            this._graph.unselectAll();
        }
        if (this._selectedNodes) {
            try {
                this._graph.selectNodes(this._selectedNodes, true);
            } catch (err) {
                this._selectedNodes = undefined;
            }
        }
    }

    private onDragEnd(params) {
        this._graph.once('dragging', this.onDragging.bind(this));
    }

    private onHoverNode(params) {
        this._graph.setOptions({ interaction: { hoverConnectedEdges: true } });
        if (!params.node.startsWith('KomponenteGA')) {
            return;
        }
        let focus = false;
        for (const node of this._selectedNodes || []) {
            if (node === params.node) {
                focus = true;
                break;
            }
        }
        if (!focus) {
            this._hoveredNode = params.node;
            this.navElementContainer.setSVG(params.node, this._visOptions.groups.KomponenteGA.color.hover.background);
        }
    }

    private onBlurNode(params) {
        if (!params.node.startsWith('KomponenteGA')) {
            return;
        }
        if (this._hoveredNode !== params.node) {
            return;
        }
        let focus = false;
        for (const node of this._selectedNodes || []) {
            if (node === params.node) {
                focus = true;
                break;
            }
        }
        this._hoveredNode = '';
        if (!focus) {
            this.navElementContainer.setSVG(params.node);
        }
    }

    private onBlurEdge(params) {
        this._graph.setOptions({ interaction: { hoverConnectedEdges: false } });
    }

    private onStabilizationIterationsDone(params) {
        this._loadingPhase = false;
    }

    private onStabilizationProgress(params) {
        if (!this._loadingPhase) {
            this._loadingPhase = true;
        }
    }

    private unselectNode() {
        this._selectedNodes = null;
        this._graph.unselectAll();
    }

    /**
    * Callback function, wird von vis für das handling Right-Mouse Event aufgerufen.
    *
    * @param [param: any] Parameter object von vis mit diserven Daten. Mehr Infos in der vis Dokumentation.
    * @returns void
    */
    private onContext(params): void {
        params.event.preventDefault();

        // find node beyound mouse
        this._rightClickSelectedNodeID = '';
        const nodeID = this._graph.getNodeAt(
            {
                x: params.event.offsetX,
                y: params.event.offsetY
            }
        );

        if (!nodeID) {
            return;
        }

        if (nodeID.toString() === navigationConfig.defaultValuesForRoot.id) {
            return;
        }

        // remember selected ID
        this._rightClickSelectedNodeID = nodeID.toString();

        const x = params.event.pageX;
        const y = params.event.pageY;

        this._contextMenuContainerElemRef.nativeElement.style.left = x + 2 + 'px';
        this._contextMenuContainerElemRef.nativeElement.style.top = y - 67 + 'px';

        this._contextMenuTrigger.openMenu();
    }

    /**
    * Callback function, wird von vis für das zoom Event aufgerufen.
    *
    * @param [param: any] Parameter object von vis mit diserven Daten. Mehr Infos in der vis Dokumentation.
    * @returns void
    */
    private onZoom(graph: vis.Network, maxscale: number, params): void {
        if (params.direction === '-' && params.scale <= maxscale) {
            const moveToOptions: vis.MoveToOptions = {
                scale: maxscale,
                position: {
                    x: 0,
                    y: 0,
                },
            };
            graph.moveTo(moveToOptions);
        }
    }

    /**
    * Handler function zum Popup Menü.
    * Initiiert Request zum laden von Details.
    *
    * @param keine
    * @returns [void]
    */
    public onContextDetails(): void {
        // sanity
        if (!this.navElementContainer.getVirtualRoot()) {
            console.warn('Kein virtueller root');
            return;
        }

        // Suchergebnis
        if (this.navElementContainer.getVirtualRootId() === navigationConfig.defaultValuesForRoot.id) {
            return;
        }

        this._loadingPhase = true;

        // -->>ASY
        this._navigationService.loadElements1stDetail(
            this.navElementContainer.getVirtualRootId()
        )
            .then((boolResultASY: IBoolResult) => {
                this._loadingPhase = false;

                // result available
                if (boolResultASY.result) {
                    return;
                }

                // no data
                this._messageSnackService.showSnackWarning(boolResultASY.message.message, 'NavElemGraphViewComponent');
            })
            .catch((err: ErrorMessage) => {
                this._loadingPhase = false;
                this._messageSnackService.showSnackError(err.message, 'NavElemGraphViewComponent');
            });
    }

    /**
    * Handler function zum Popup Menü.
    * Initiiert Request zum nachladen von Elementen.
    *
    * @param keine
    * @returns [void]
    */
    public onContextExpandNode(): void {
        // Suchergebnis
        if (this._rightClickSelectedNodeID === navigationConfig.defaultValuesForRoot.id) {
            this._messageSnackService.showSnackWarning('Suchergebnis kann nicht expandiert werden', 'NavElemGraphViewComponent');
            return;
        }

        this._loadingPhase = true;

        // set object rootToExtend in navElementContainer - to verify 'root' of result from backend
        this.navElementContainer.setRootToExtend(this._rightClickSelectedNodeID);

        // -->> ASYNC
        this._navigationService.loadElements1stExtension(
            this._rightClickSelectedNodeID,
        )
            .then((boolResultASY: IBoolResult) => {

                // result available
                if (boolResultASY.result) {
                    // parse searchResult
                    this.navElementContainer.computeExtendedSearchResult(
                        this._store.getState().navigationState.elementsResult1stExtended,
                        this._store.getState().navigationState.config);
                    this.navElementContainer.applyDisplayFilter(this.elementOptions);

                    // set edge group pairs for selection
                    const displayOptionEdges: INavGraphDisplayOptionEdges[] =
                        _.cloneDeep(this._store.getState().navigationState.element1stDisplayOptionEdges);
                    this.navElementContainer.fillDisplayOptionEdges(displayOptionEdges);
                    this._store.dispatch(navigationStore1stDisplayOptionEdges(displayOptionEdges));

                    this._graph.stabilize(400);
                    // clean up
                    return;
                }

                this._loadingPhase = false;
                // no data
                this._messageSnackService.showSnackWarning(boolResultASY.message.message, 'NavElemGraphViewComponent');
            })
            .catch((err: ErrorMessage) => {
                this._loadingPhase = false;
                this._messageSnackService.showSnackError(err.message, 'NavElemGraphViewComponent');
            });
    }

    /**
    * Handler function zum Popup Menü.
    * Initiiert Request initialen Request für das selektierte Elementen.
    *
    * @param keine
    * @returns [void]
    */
    public onContextReduceNode(): void {
        // Suchergebnis
        if (this._rightClickSelectedNodeID === navigationConfig.defaultValuesForRoot.id) {
            this._messageSnackService.showSnackWarning('Suchergebnis kann nicht reduziert werden', 'NavElemGraphViewComponent');
            return;
        }

        this._loadingPhase = true;

        // -->> ASYNC
        this._navigationService.loadElements1stReduced(
            this._rightClickSelectedNodeID
        )
            .then((boolResultASY: IBoolResult) => {

                // result available
                if (boolResultASY.result) {
                    return;
                }
                this._loadingPhase = false;
                // no data
                this._messageSnackService.showSnackWarning(boolResultASY.message.message, 'NavElemGraphViewComponent');
            })
            .catch((err: ErrorMessage) => {
                this._loadingPhase = false;
                this._messageSnackService.showSnackError(err.message, 'NavElemGraphViewComponent');
            });
    }

    public onCreateElement() {
        // Suchergebnis
        if (this._rightClickSelectedNodeID === navigationConfig.defaultValuesForRoot.id) {
            this._messageSnackService.showSnackWarning('Keine Neuanlage für Element: Suchergebnis zulässig', 'NavElemGraphViewComponent');
            return;
        }

        // sanity I
        const selectedNode = this.navElementContainer.findNodeWithID(this._rightClickSelectedNodeID);
        if (!selectedNode) {
            console.warn('Kein virtueller root');
            return;
        }

        // setze type im Falls von root
        if (selectedNode.group === 'root') {
            selectedNode.group = selectedNode.id.split('/')[0];
        }

        this.titleMdlgCreateElement = this._titleMdlgCreateElement;
        const config = this._store.getState().navigationState.config;
        const configDict = config['dictionary'];
        if (!configDict) {
            console.warn('Dictionary nicht verfügbar');
            return;
        }
        const collection = _.find(configDict, item =>
            item.key === selectedNode.group && item.collectionType === 'document');
        this.subtitleMdlgCreateElement = this._subtitleMdlgCreateElement + collection.short + ' ' + selectedNode.label;     // z.B. Meldung

        // reset schema data - damit Dialog ohne Detail geöffnet wird
        this._store.dispatch(navigationStoreSchema(null));

        // open dialog
        this._createElementService.open(
            this.titleMdlgCreateElement,
            this.subtitleMdlgCreateElement,
            selectedNode
        ).subscribe(result => {      // null || INavNewEdgeAndElement
            try {
                if (result) {
                    this.onCreateElementSubmit(result as INavNewEdgeAndElement);
                }
            } catch (err) {
                console.warn(err);
            }
        });
    }

    public async onDeleteElement() {
        // Suchergebnis
        if (this._rightClickSelectedNodeID === navigationConfig.defaultValuesForRoot.id) {
            this._messageSnackService.showSnackWarning('Suchergebnis kann nicht gelöscht werden!', 'NavElemGraphViewComponent');
            return;
        }

        const node = this.navElementContainer.findNodeWithID(this._rightClickSelectedNodeID);
        let message = `Element ${node.group} ${node.label} wird gelöscht.`;

        const [collection] = node.id.split('/');
        switch (collection) {
            case 'AnlageEntrauchungsanlage':
            case 'AnlageRltAnlage':
            case 'AnlageFoerderanlage':
                message = `${message}
                Zusätzlich werden auch alle 'steuert' und 'schaltet' Beziehungen von dieser Anlage und ihrer Komponenten gelöscht.`;
                break;
        }
        const dlgResult = await this._confirmDialogService.open(
            'Element löschen',
            `${message} Fortfahren?`,
            true,
            'Abbrechen',
            'Ok',
        ).toPromise();
        if (dlgResult) {
            this._loadingPhase = true;

            const edgesToRemove = new Array<string>();

            const toDelete = [node.id];
            switch (collection) {
                case 'AnlageEntrauchungsanlage':
                case 'AnlageRltAnlage':
                case 'AnlageFoerderanlage':
                    const result = await this._navigationService.getRawGraphdata(node.id,
                        { inDepth: 2, outDepth: 2, maxnodes: 100, edges: ['Schaltet', 'GehoertZu'] });
                    if (result.edges.Schaltet) {
                        toDelete.push(...result.edges.Schaltet.map(edge => edge._id));
                    }
                    break;
            }

            let undeletedElements = await this.deleteElements(toDelete);
            if (undeletedElements) {
                const edgeCount = undeletedElements.length - 1;
                const dlgResult2 = await this._confirmDialogService.open(
                    'Element löschen',
                    `Das Löschen dieses Elements führt zusätzlich zur Löschung von ${edgeCount === 1 ?
                        'einer Beziehung' :
                        `${edgeCount} Beziehungen`}.
            Fortfahren?`,
                    true,
                    'Abbrechen',
                    'Ok',
                ).toPromise();
                if (dlgResult2) {
                    edgesToRemove.push(...undeletedElements.filter((val) => val !== node.id));
                    undeletedElements = await this.deleteElements(undeletedElements);
                } else {
                    this._messageSnackService.logMessage(
                        'INFO',
                        {
                            module: 'NavElemGraphViewComponent',
                            uiMessage: `Löschen von Element ${node.group} ${node.label} abgebrochen!`,
                        }
                    );
                    this._loadingPhase = false;
                    return;
                }

            }
            if (undeletedElements) {
                this._messageSnackService.logMessage(
                    'ERROR',
                    {
                        module: 'NavElemGraphViewComponent',
                        uiMessage: 'Löschen abgebrochen. Ein anderer Nutzer hat die Daten geändert!',
                    }
                );
            } else {
                this._messageSnackService.logMessage(
                    'SUCCESS',
                    {
                        module: 'NavElemGraphViewComponent',
                        uiMessage: 'Element erfolgreich gelöscht!',
                    }
                );
                edgesToRemove.forEach((edge) => this.navElementContainer.removeEdgeWithID(edge));
                this.navElementContainer.removeNodeWithID(node.id);
            }
            this._loadingPhase = false;
        }
    }


    private async deleteElements(elementIDs: string[]): Promise<string[]> {
        let toDelete = new Array<string>();
        toDelete.push(...elementIDs);
        try {
            const result = await this._navigationService.deleteElements(toDelete);
            toDelete = undefined;
        } catch (err) {
            const [, arrString] = err.errorObject.error.split(':');
            const edges: string[] = JSON.parse(arrString);
            toDelete.push(...edges);
        }
        return toDelete;
    }

    // ---------------------------------------------------------------------------------------------
    // -- handlers - create element
    // ---------------------------------------------------------------------------------------------
    public onCreateElementSubmit(newEdgeAndElement: INavNewEdgeAndElement) {

        this._loadingPhase = true;

        // -->>ASY
        this._navigationService.newEdgeAndElement(
            newEdgeAndElement
        )
            .then((data: any) => {

                let nodeFrom: INavElementsNode = null;

                // result available
                if (data && data.document && data.edge) {

                    // hole dict eintrag für edge
                    const config = this._store.getState().navigationState.config;
                    const configDict = config['dictionary'];
                    if (!configDict) {
                        console.warn('Dictionary nicht verfügbar');
                        return;
                    }
                    const dictEdgeItem: any = _.find(configDict, item =>
                        item.key === newEdgeAndElement.edgeType && item.collectionType === 'edge');

                    // node from
                    nodeFrom = gNavElementContainer.findNodeWithID(newEdgeAndElement.fromID);

                    // create node child object
                    // Hinweis: addChild prüft auf Existenz
                    const subType = this.navElementContainer.getSubtype(newEdgeAndElement.elemType, config);
                    gNavElementContainer.addNode({
                        id: data.document._id,
                        group: newEdgeAndElement.elemType,
                        label: data.document.bezeichnung,
                        titel: data.document.anmerkung,
                        typ: data.document[subType],
                        art: data.document.art,
                        anlage: data.document.anlage,
                        display: true
                    });

                    // create node child object
                    // Hinweis: addChild prüft auf Existenz
                    gNavElementContainer.addEdge(
                        {
                            key: data.edge._key,
                            rev: data.edge._rev,
                            id: data.edge._id,
                            from: data.edge._from,
                            to: data.edge._to,
                            group: newEdgeAndElement.edgeType,
                            label: newEdgeAndElement.edgeType,
                            aktion: data.edge.aktion,
                            display: true
                        });

                    if (data.edges) {
                        for (const edge of data.edges) {
                            gNavElementContainer.addEdge(
                                {
                                    key: edge._key,
                                    rev: edge._rev,
                                    id: edge._id,
                                    from: edge._from,
                                    to: edge._to,
                                    group: data.edgeCollection,
                                    label: data.edgeCollection,
                                    aktion: edge.aktion,
                                    display: true
                                });
                        }
                    }
                    // update graph
                    this._graph.stabilize(400);

                    this._messageSnackService.showSnackSuccess('Neues Element wurde gespeichert');
                    return;

                    // mocking case
                } else if (appConfig.dev.mockingMode) {

                    // hole dict eintrag für edge
                    const config = this._store.getState().navigationState.config;
                    const configDict = config['dictionary'];
                    if (!configDict) {
                        console.warn('Dictionary nicht verfügbar');
                        return;
                    }
                    const dictEdgeItem: any = _.find(configDict, item =>
                        item.key === newEdgeAndElement.edgeType && item.collectionType === 'edge');

                    // node from
                    nodeFrom = gNavElementContainer.findNodeWithID(newEdgeAndElement.fromID);

                    // create node child object
                    // Hinweis: addChild prüft auf Existenz
                    const rand = Math.floor(Math.random() * 10000);
                    gNavElementContainer.addNodeGroup(newEdgeAndElement.elemType).addChild(
                        {
                            id: newEdgeAndElement.elemType + '/' + rand.toString(),
                            group: newEdgeAndElement.elemType,
                            label: rand.toString(),
                            titel: newEdgeAndElement.elemType + '/' + rand.toString(),
                            typ: undefined,
                            art: undefined,
                            display: true
                        }
                    );

                    // direction
                    let from = newEdgeAndElement.fromID;
                    let to = newEdgeAndElement.elemType + '/' + rand.toString();
                    if (newEdgeAndElement.direction === 'from') {
                        to = newEdgeAndElement.fromID;
                        from = newEdgeAndElement.elemType + '/' + rand.toString();
                    }
                    // create node child object
                    // Hinweis: addChild prüft auf Existenz
                    gNavElementContainer.addEdgeGroup(newEdgeAndElement.edgeType).addChild(
                        {
                            key: '',
                            rev: '',
                            id: newEdgeAndElement.edgeType + '/' + rand.toString(),
                            from: from,
                            to: to,
                            group: newEdgeAndElement.edgeType,
                            label: dictEdgeItem.fwd + ' ' + newEdgeAndElement.fromID,
                            aktion: undefined,
                            display: true
                        }
                    );

                    this._messageSnackService.showSnackSuccess('Mocking: Neue Kanten-Element Beziehung wurden gespeichert');
                    return;
                }
                this._loadingPhase = false;
                // no data
                this._messageSnackService.showSnackWarning('Anlegen des Elements ist fehlgeschlagen', 'NavigationContComponent');
            })
            .catch((err: ErrorMessage) => {
                this._loadingPhase = false;
                if (err.code === 'missingDefaults') {
                    this._confirmDialogService.openHelpMessage('Standart-Schaltungen', err.uiMessage, appConfig.app.showCreateDefaultsDialog).subscribe(
                        (res) => {
                            newEdgeAndElement.createDefaults = res;
                            this.onCreateElementSubmit(newEdgeAndElement);
                        }
                    );
                } else if (err.code === 'missingComponentDefaults') {
                    this._confirmDialogService.openHelpMessage('Standart-Schaltungen', err.uiMessage, appConfig.app.showCreateDefaultsDialog).subscribe(
                        (res) => {
                            newEdgeAndElement.createComponentDefaults = res;
                            this.onCreateElementSubmit(newEdgeAndElement);
                        }
                    );
                } else if (err.code === 'missingFGConnection') {
                    this._confirmDialogService.openHelpMessage('Manuell ausgelöste Funktionsgruppe', err.uiMessage, true).subscribe(
                        (res) => {
                            newEdgeAndElement.createFGConnection = res;
                            this.onCreateElementSubmit(newEdgeAndElement);
                        }
                    );
                } else {
                    this._messageSnackService.logMessage('ERROR', {
                        consoleMessage: err.message,
                        duration: 3000,
                        module: 'NavigationContComponent',
                        uiMessage: err.uiMessage || err.message,
                    });
                }
            });
    }

    public onCreateElementError(event) {
        console.error(event);
    }

    public setReadonly(hasRole: boolean) {
        this.readonly = !hasRole;
    }
}





// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/compv/nav-graph1/nav-graph1.ts